export const STEP_EQUIPEMENT = "step-equipement";
export const STEP_OWNER = "step-owner";
export const STEP_TENANT = "step-tenant";
